<template>
<v-dialog v-model="popup.show" max-width="500px" transition="slide-y-reverse-transition" persistent scrollable>
  <v-card>
    <v-card-title class="pa-0">
      <v-toolbar class="pl-2" color="transparent" flat>
        <v-spacer></v-spacer>
        <v-toolbar-title class="headline ml-4">{{popup.type}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          v-if="popup.type != 'Registering'"
          color="error"
          @click.native="popup.show = false"
          icon
          flat
        ><v-icon>close</v-icon></v-btn>
      </v-toolbar>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-layout row wrap>
        <v-flex v-if="popup.type == 'Register'" xs12 class="text-xs-center px-3 pb-3 pt-1">
          <div class="subheading pb-2">Registering for <b>{{newC.name}}</b></div>
          <div class="subheading pb-2"><b>Online Access Time:</b> {{newC.onlineDays}} Days</div>
          <div v-if="newC.type == 'Live'" class="subheading pb-2">
            <span><b>Dates:</b></span> <span v-for="date, i in newC.dates" :key="i">{{date}}{{i < newC.dates.length - 1 ? ',' : ''}}</span>
          </div>
          <div class="subheading pb-3"><b>Price:</b> ${{parseInt(newC.price).toFixed(2)}}</div>
          <div v-if="!user" class="subheading pb-0">
            <v-icon color="error" medium>error</v-icon>
            <span><b>Please sign in to register</b></span>
          </div>
          <div>
            <v-btn v-if="user" @click.native="broadcast('canRegister', newC.key)" color="success" depressed>Continue</v-btn>
            <v-btn v-else @click.native="goToSignIn('/sign-in')" color="success" depressed>Sign In</v-btn>
          </div>
        </v-flex>
        <v-flex v-if="popup.type == 'Registering'" xs12 class="text-xs-center px-3 pb-3 pt-1">
          <div v-if="payment">
            <div v-if="payment.processing">
              <div class="subheading pb-2">Please wait while your payment is being processed</div>
              <div class="subheading pb-2">
                <v-progress-circular color="secondary" indeterminate></v-progress-circular>
              </div>
            </div>
            <div v-else-if="payment.charge">
              <div v-if="payment.charge.failure_message">
                <div class="subheading pb-2"><span class="error--text">ERROR</span> {{payment.charge.failure_message}}</div>
                <div class="subheading pb-2">Your card has not been charged</div>
              </div>
              <div v-else>
                <div class="subheading pb-2"><span class="success--text">SUCCESS</span> You have completed registeration!</div>
                <div>
                  <v-btn to="/my-courses" color="primary" depressed>My Courses</v-btn>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="subheading pb-2">Please wait while your payment is being processed</div>
            <div class="subheading pb-2">
              <v-progress-circular color="secondary" indeterminate></v-progress-circular>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</v-dialog>
</template>

<script>
import {coursesEvent} from '../../../main'
export default {
  props: ['popup', 'courseData', 'paymentId'],
  computed: {
    newC () {
      return this.courseData ? this.courseData : {}
    },
    user () {
      return this.$store.getters.user
    },
    payment () {
      return this.$store.getters.paymentByKey(this.paymentId)
    }
  },
  methods: {
    broadcast (event, data) {
      if (typeof data === 'undefined') coursesEvent.$emit(event)
      else coursesEvent.$emit(event, data)
      this.popup.show = false
    },
    goToSignIn (path) {
      this.$store.dispatch('setUserRoute', this.$route.fullPath)
      this.$store.dispatch('setCourseToRegister', this.newC.key)
      if (path) this.$router.push(path)
      this.popup.show = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/site/courses/RegisterPopup.vue